import React from 'react';
import PropTypes from 'prop-types';
import { isoToBrDate } from 'volto-ministerio-publico-federal/utils/brDate';

const describeDate = ({ date_start: start, date_end: end }) => {
  if (start && end) {
    return `${isoToBrDate(start)} - ${isoToBrDate(end)}`;
  }
  if (start) {
    return `a partir de ${isoToBrDate(start)}`;
  }
  if (end) {
    return `até ${isoToBrDate(end)}`;
  }

  return '';
};

const NewsFilterSummary = ({ filters, unidades }) => {
  const tags = [];

  if (filters.searchable_text) {
    tags.push(['Busca', filters.searchable_text]);
  }

  if (filters.unidade) {
    const unidade = (unidades || []).find(
      (item) => item.value === filters.unidade,
    );

    // O token é o fallback enquanto o vocabulário não chegou.
    tags.push(['Unidade', unidade?.label || filters.unidade]);
  }

  const periodo = describeDate(filters);
  if (periodo) {
    tags.push(['Data', periodo]);
  }

  if (filters.subject.length === 1) {
    tags.push(['Tema', filters.subject[0]]);
  } else if (filters.subject.length > 1) {
    tags.push(['Temas', `${filters.subject.length}`]);
  }

  if (!tags.length) {
    return null;
  }

  return (
    <span className="mpf-news-filter__summary">
      <span className="mpf-news-filter__summary-label">Filtros aplicados:</span>
      {tags.map(([label, value]) => (
        <span className="mpf-news-filter__tag" key={label}>
          <strong className="mpf-news-filter__tag-label">{label}</strong>:{' '}
          {value}
        </span>
      ))}
    </span>
  );
};

NewsFilterSummary.propTypes = {
  filters: PropTypes.shape({
    subject: PropTypes.arrayOf(PropTypes.string).isRequired,
    unidade: PropTypes.string,
    searchable_text: PropTypes.string,
    date_start: PropTypes.string,
    date_end: PropTypes.string,
  }).isRequired,
  unidades: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
};

NewsFilterSummary.defaultProps = {
  unidades: [],
};

export default NewsFilterSummary;
